{
  "actionbar.actions": "Radnje",
  "actionbar.actionsAvailable": "Dostupne radnje.",
  "actionbar.clearSelection": "Poništi odabir",
  "actionbar.selected": "Odabrano: { count }",
  "actionbar.selectedAll": "Sve je odabrano",
  "button.pending": "u tijeku",
  "contextualhelp.help": "Pomoć",
  "contextualhelp.info": "Informacije",
  "dialog.alert": "Upozorenje",
  "dialog.dismiss": "Odbaci",
  "dropzone.replaceMessage": "Ispustite datoteku za zamjenu",
  "inlinealert.informative": "Informacije",
  "inlinealert.negative": "Pogreška",
  "inlinealert.notice": "Upozorenje",
  "inlinealert.positive": "Uspješno",
  "label.(optional)": "(opcionalno)",
  "label.(required)": "(obvezno)",
  "menu.moreActions": "Dodatne radnje",
  "picker.placeholder": "Odaberite…",
  "slider.maximum": "Najviše",
  "slider.minimum": "Najmanje",
  "table.loading": "Učitavam...",
  "table.loadingMore": "Učitavam još...",
  "table.resizeColumn": "Promijeni veličinu stupca",
  "table.sortAscending": "Sortiraj uzlazno",
  "table.sortDescending": "Sortiraj silazno",
  "tag.actions": "Radnje",
  "tag.hideButtonLabel": "Prikaži manje",
  "tag.noTags": "Nema",
  "tag.showAllButtonLabel": "Prikaži sve ({tagCount, number})",
  "breadcrumbs.more": "Više stavki"
}